import axios from 'axios';
import config from '../config'

export default {

    /**
     * Get ip info.
     *
     * @returns {AxiosPromise<any>}
     */
    getIpInfo() {
        return axios.get(config.auth.AUTH_TOKEN_IP_INFO_URL, {
            headers: {
                Authorization: `Bearer ${config.auth.AUTH_TOKEN_IP_INFO}`
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/services/IPService.js